import browser from '@openclassrooms/utils/browser';

export default function loadAnalyticsFromWindow() {
  const { loadAnalytics = () => {} } = browser.window;
  loadAnalytics();
}
